import { useEffect, useState, React } from 'react';
import { useT } from '../i18n';
import { ethers } from 'ethers';
import {
  luckBlocksAddress,
  luckBlocksWAddress,
  ethLuckBlocksAddress,
  ethluckBlocksWAddress,
  maticLuckBlocksAddress,
  maticLuckBlocksWAddress,
  CRANNILuckBlocksAddress,
  CRANNILuckBlocksWAddress,
  MultiCall,
  provider,
  wsprovider,
  bckpProvider,
  alchemyBase,
} from '../.config';
import LuckBlocks from '../abi/LuckBlocks.json';
import Multicall from '../abi/Multicall.json';
import CarouselPage from '../Carousel';
import { useAccount } from 'wagmi';
import btc from '../assets/utility/bitcoin.png';
import eth from '../assets/utility/ethereum.png';
import matic from '../assets/utility/matic.png';
import CRANNI from '../assets/utility/CRANNI.png';
import { useAppKitAccount } from "@reown/appkit/react";
import { Ticket as TicketIcon, Wallet } from "lucide-react";
import Spinner from "../components/UI/Spinner";
import EmptyState from "../components/UI/EmptyState";

const MyTickets = () => {
  const t = useT();
  const [tickets, setTickets] = useState([]);
  const [ticketsW, setTicketsW] = useState([]);
  const [ticketsP, setTicketsP] = useState([]);
  const [ticketsPW, setTicketsPW] = useState([]);
  const [formInput, updateFormInput] = useState({
    drawId: 0,
  });
  const [formInputW, updateFormInputW] = useState({
    drawId: 0,
  });
  const [currentDraw, updateCurrentDraw] = useState(0);
  const [currentWDraw, updateCurrentWDraw] = useState(0);
  const [lottery, setLottery] = useState('fetch');
  const [ticketType, setTicketType] = useState('Current');
  const { address, isConnected, caipAddress, status, embeddedWalletInfo } = useAppKitAccount()
  const [loading, setLoading] = useState(true);

  const changeLotteryToBTC = () => {
    setLottery('Bitcoin');
    getCurrentDraw('Bitcoin');
  };
  const changeLotteryToETH = () => {
    setLottery('Ethereum');
    getCurrentDraw('Ethereum');
  };

  const changeLotteryToMATIC = () => {
    setLottery('Matic');
    getCurrentDraw('Matic');
  };
  const changeLotteryToCRANNI = () => {
    setLottery('CRANNI');
    getCurrentDraw('CRANNI');
  };

  let ticketArray = [];
  let ticketArrayW = [];
  let ticketArrayP = [];
  let ticketArrayPW = [];

  const resetTickets = () => {
    ticketArray = [];
    ticketArrayW = [];
    ticketArrayP = [];
    ticketArrayPW = [];
    setTickets([]);
    setTicketsW([]);
    setTicketsP([]);
    setTicketsPW([]);
    setLoading(true);
    setTimeout(() => getAllMyTickets(), 10000);
  };

  async function getCurrentDraw(lottery) {
    let contractAddress;
    let wcontractAddress;

    if (lottery === 'Bitcoin') {
      contractAddress = luckBlocksAddress;
      wcontractAddress = luckBlocksWAddress;
    } else if (lottery === 'Ethereum') {
      contractAddress = ethLuckBlocksAddress;
      wcontractAddress = ethluckBlocksWAddress;
    } else if (lottery === 'Matic') {
      contractAddress = maticLuckBlocksAddress;
      wcontractAddress = maticLuckBlocksWAddress;
    } else if (lottery === 'CRANNI') {
      contractAddress = CRANNILuckBlocksAddress;
      wcontractAddress = CRANNILuckBlocksWAddress;
    }

    const contract = new ethers.Contract(
      contractAddress,
      LuckBlocks.abi,
      wsprovider
    );
    const wcontract = new ethers.Contract(
      wcontractAddress,
      LuckBlocks.abi,
      bckpProvider
    );

    let draw = await contract.requestCounter();
    let wdraw = await wcontract.requestCounter();
    draw = parseInt(draw);
    //  console.log(draw);
    updateCurrentDraw(draw);
    wdraw = parseInt(wdraw);
    updateCurrentWDraw(wdraw);
  }

  async function getPastTicket(lottery, drawId) {
    let contractAddress;

    if (lottery === 'Bitcoin') {
      contractAddress = luckBlocksAddress;
    } else if (lottery === 'Ethereum') {
      contractAddress = ethLuckBlocksAddress;
    } else if (lottery === 'Matic') {
      contractAddress = maticLuckBlocksAddress;
    } else if (lottery === 'CRANNI') {
      contractAddress = CRANNILuckBlocksAddress;
    }

    const contract = new ethers.Contract(MultiCall, Multicall.abi, wsprovider);

    if (isConnected) {
      const ticketInfos = await contract.getPastDrawTickets(
        contractAddress,
        drawId,
        address
      );


      const uniquePastDailyTickets = new Set();

      for (const ticket of ticketInfos) {
        const ticketDraw = ticket[0];
        const ticketId = ticket[1];
        const uniqueKey = `${ticketDraw}-${ticketId}`;

        // Verificar se o ticket já existe
        if (!uniquePastDailyTickets.has(uniqueKey)) {
          uniquePastDailyTickets.add(uniqueKey);

          const winner = ticket[2];

          ticketArrayP.push({
            weekly: 3,
            lottery: ticketDraw,
            drawId: parseInt(drawId),
            ticketId: parseInt(ticketId),
            winner: winner,
            owner: address,
          });
        }
      }
    }
    setTicketsP(ticketArrayP);
  }

  async function getPastTicketW(lottery, drawId) {
    let contractAddress;

    if (lottery === 'Bitcoin') {
      contractAddress = luckBlocksWAddress;
    } else if (lottery === 'Ethereum') {
      contractAddress = ethluckBlocksWAddress;
    } else if (lottery === 'Matic') {
      contractAddress = maticLuckBlocksWAddress;
    } else if (lottery === 'CRANNI') {
      contractAddress = CRANNILuckBlocksWAddress;
    }

    const contract = new ethers.Contract(MultiCall, Multicall.abi, bckpProvider);

    if (isConnected) {
      const ticketInfos = await contract.getPastDrawTickets(
        contractAddress,
        drawId,
        address
      );

      const uniquePastWeeklyTickets = new Set();

      for (const ticket of ticketInfos) {
        const ticketDraw = ticket[0];
        const ticketId = ticket[1];
        const uniqueKey = `${ticketDraw}-${ticketId}`;

        // Verificar se o ticket já existe
        if (!uniquePastWeeklyTickets.has(uniqueKey)) {
          uniquePastWeeklyTickets.add(uniqueKey);

          const winner = ticket[2];

          ticketArrayPW.push({
            weekly: 3,
            lottery: ticketDraw,
            drawId: parseInt(drawId),
            ticketId: parseInt(ticketId),
            winner: winner,
            owner: address,
          });
        }
      }
    }
    setTicketsPW(ticketArrayPW);
  }

  async function getAllMyTickets() {
    const contract = new ethers.Contract(MultiCall, Multicall.abi, bckpProvider);
    const bckpContract = new ethers.Contract(MultiCall, Multicall.abi, provider);

    if (isConnected) {
      const lotteryInfos = await bckpContract.getLotteryInfos();
      const lotteryInfosW = await bckpContract.getLotteryInfosW();
      const tickets = await contract.getAllMyTickets(address);
      const ticketsW = await contract.getAllMyTicketsW(address);


      const uniqueDailyTickets = new Set();
      const uniqueWeeklyTickets = new Set();


      for (const ticket of tickets) {
        const ticketDraw = ticket[0];
        const ticketId = ticket[1];
        const uniqueKey = `${ticketDraw}-${ticketId}`;


        if (!uniqueDailyTickets.has(uniqueKey)) {
          uniqueDailyTickets.add(uniqueKey);

          let drawId;
          let jackpotWinC;
          let jackpotWinU;
          let getNextSpin;

          if (ticketDraw === 'Bitcoin') {
            drawId = lotteryInfos[0][1];
            jackpotWinC = lotteryInfos[0][3];
            jackpotWinU = lotteryInfos[0][4];
            getNextSpin = lotteryInfos[0][2] * 1000 + 86400000;
          } else if (ticketDraw === 'Ethereum') {
            drawId = lotteryInfos[1][1];
            jackpotWinC = lotteryInfos[1][3];
            jackpotWinU = lotteryInfos[1][4];
            getNextSpin = lotteryInfos[1][2] * 1000 + 86400000;
          } else if (ticketDraw === 'Matic') {
            drawId = lotteryInfos[2][1];
            jackpotWinC = lotteryInfos[2][3];
            jackpotWinU = lotteryInfos[2][4];
            getNextSpin = lotteryInfos[2][2] * 1000 + 86400000;
          } else {
            drawId = lotteryInfos[3][1];
            jackpotWinC = lotteryInfos[3][3];
            jackpotWinU = lotteryInfos[3][4];
            getNextSpin = lotteryInfos[3][2] * 1000 + 86400000;
          }

          const formattedJpWei = ethers.utils.formatUnits(
            jackpotWinC.toString(),
            ticketDraw === 'Bitcoin' || ticketDraw === 'CRANNI' ? 8 : 'ether'
          );
          const formattedJpUsd = ethers.utils.formatUnits(
            jackpotWinU.toString(),
            6
          );

          ticketArray.push({
            weekly: 0,
            lottery: ticketDraw,
            drawId: parseInt(drawId),
            ticketId: parseInt(ticketId),
            nextSpin: parseInt(getNextSpin),
            jackpotWinC:
              ticketDraw === 'CRANNI' || ticketDraw === 'Matic'
                ? parseFloat(formattedJpWei).toFixed(3)
                : parseFloat(formattedJpWei).toFixed(4),
            jackpotWinU: parseFloat(formattedJpUsd).toFixed(2),
            owner: address,
          });
        }
      }

      for (const ticketW of ticketsW) {
        const ticketDraw = ticketW[0];
        const ticketId = ticketW[1];
        const uniqueKey = `${ticketDraw}-${ticketId}`;


        if (!uniqueWeeklyTickets.has(uniqueKey)) {
          uniqueWeeklyTickets.add(uniqueKey);

          let drawId;
          let jackpotWinC;
          let jackpotWinU;
          let getNextSpin;

          if (ticketDraw === 'Bitcoin') {
            drawId = lotteryInfosW[0][1];
            jackpotWinC = lotteryInfosW[0][3];
            jackpotWinU = lotteryInfosW[0][4];
            getNextSpin = lotteryInfosW[0][2] * 1000 + 604800000;
          } else if (ticketDraw === 'Ethereum') {
            drawId = lotteryInfosW[1][1];
            jackpotWinC = lotteryInfosW[1][3];
            jackpotWinU = lotteryInfosW[1][4];
            getNextSpin = lotteryInfosW[1][2] * 1000 + 604800000;
          } else if (ticketDraw === 'Matic') {
            drawId = lotteryInfosW[2][1];
            jackpotWinC = lotteryInfosW[2][3];
            jackpotWinU = lotteryInfosW[2][4];
            getNextSpin = lotteryInfosW[2][2] * 1000 + 604800000;
          } else {
            drawId = lotteryInfosW[3][1];
            jackpotWinC = lotteryInfosW[3][3];
            jackpotWinU = lotteryInfosW[3][4];
            getNextSpin = lotteryInfosW[3][2] * 1000 + 604800000;
          }

          const formattedJpWei = ethers.utils.formatUnits(
            jackpotWinC.toString(),
            ticketDraw === 'Bitcoin' || ticketDraw === 'CRANNI' ? 8 : 'ether'
          );
          const formattedJpUsd = ethers.utils.formatUnits(
            jackpotWinU.toString(),
            6
          );

          ticketArrayW.push({
            weekly: 1,
            lottery: ticketDraw,
            drawId: parseInt(drawId),
            ticketId: parseInt(ticketId),
            nextSpin: parseInt(getNextSpin),
            jackpotWinC:
              ticketDraw === 'CRANNI' || ticketDraw === 'Matic'
                ? parseFloat(formattedJpWei).toFixed(3)
                : parseFloat(formattedJpWei).toFixed(4),
            jackpotWinU: parseFloat(formattedJpUsd).toFixed(2),
            owner: address,
          });
        }
      }
    }

    console.log(ticketArray);
    setTickets(ticketArray);
    setTicketsW(ticketArrayW);
  }

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Set loading to false after a brief delay
    }, 3000);
  }, [tickets, ticketsW, ticketsP, ticketsPW]);

  useEffect(() => {
    if (ticketType === 'Current') {
      setTicketsP([]);
      setTicketsPW([]);
      setLoading(true);
      getAllMyTickets();
    } else if (ticketType === 'Past') {
      setTickets([]);
      setTicketsW([]);
      setLoading(true);
      getPastTicket(lottery, 0);
      getPastTicketW(lottery, 0);
    }
  }, [ticketType]);

  useEffect(() => {
    if (lottery == 'fetch') {
      changeLotteryToBTC();
      getPastTicket(lottery, 0);
      getPastTicketW(lottery, 0);
    }
  }, []);

  useEffect(() => {
    resetTickets();
  }, [address, isConnected]);

  useEffect(() => {
    setLoading(true);
    const { drawId } = formInput;
    setTicketsP([]);
    getPastTicket(lottery, drawId);
  }, [formInput, lottery]);

  useEffect(() => {
    setLoading(true);
    const { drawId } = formInputW;
    setTicketsPW([]);
    getPastTicketW(lottery, drawId);
  }, [formInputW, lottery]);

  const LOTTERIES = [
    { key: 'Bitcoin', label: 'BTC', icon: btc, onSelect: changeLotteryToBTC },
    { key: 'Ethereum', label: 'ETH', icon: eth, onSelect: changeLotteryToETH },
    { key: 'Matic', label: 'POL', icon: matic, onSelect: changeLotteryToMATIC },
    { key: 'CRANNI', label: 'CRANNI', icon: CRANNI, onSelect: changeLotteryToCRANNI },
  ];

  const TicketGroup = ({ title, subtitle, items, tone }) => (
    <section className="lb-card p-5 sm:p-7">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="lb-eyebrow">{subtitle}</p>
          <h2 className="lb-heading mt-1 text-2xl sm:text-3xl">{title}</h2>
        </div>
        {!loading && items.length > 0 && (
          <span className={`lb-chip notranslate ${tone === 'gold' ? 'lb-chip-gold' : 'lb-chip-cyan'}`}>
            {items.length} {items.length === 1 ? 'ticket' : 'tickets'}
          </span>
        )}
      </div>

      <div className="mt-6">
        {loading ? (
          <div className="py-12">
            <Spinner size="lg" />
          </div>
        ) : items.length > 0 ? (
          <CarouselPage tickets={items} resetTickets={resetTickets} />
        ) : (
          <EmptyState
            title={t('tickets.emptyTitle')}
            message={t('tickets.emptyMessage')}
            icon={TicketIcon}
          />
        )}
      </div>
    </section>
  );

  const DrawIdPicker = ({ label, value, max, onChange }) => (
    <div className="lb-tile-soft flex flex-wrap items-end gap-4 p-4">
      <div>
        <label htmlFor={`draw-${label}`} className="lb-label">
          {t('item.drawId')}
        </label>
        <input
          id={`draw-${label}`}
          type="number"
          min={0}
          max={max}
          value={value}
          onInput={onChange}
          className="lb-input lb-num mt-2 w-[120px] text-center text-lg"
        />
      </div>
      <p className="pb-2 text-sm text-white/50">
        Current draw:{' '}
        <span className="notranslate lb-num font-bold text-white">{max}</span>
      </p>
    </div>
  );

  return (
    <div className="lb-page relative w-full px-2 py-8 sm:px-4 sm:py-10">
      <div className="relative mx-auto w-full max-w-screen-xl">
        <div className="lb-shell">
          {/* Header + view switch */}
          <div className="flex flex-col gap-5 border-b border-white/5 px-5 py-6 sm:px-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex items-center gap-4">
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border border-amber-400/30 bg-amber-400/10">
                <TicketIcon className="h-6 w-6 text-amber-300" aria-hidden="true" />
              </div>
              <div>
                <p className="lb-eyebrow">{t('tickets.eyebrow')}</p>
                <h1 className="lb-heading mt-1 text-2xl sm:text-3xl">{t('tickets.title')}</h1>
              </div>
            </div>

            <div className="lb-seg self-start lg:self-auto">
              <button
                onClick={() => setTicketType('Current')}
                data-active={ticketType === 'Current'}
                data-tone="gold"
                className="lb-seg-item"
              >
                {t('tickets.currentDraws')}
              </button>
              <button
                onClick={() => setTicketType('Past')}
                data-active={ticketType === 'Past'}
                data-tone="gold"
                className="lb-seg-item"
              >
                {t('tickets.pastDraws')}
              </button>
            </div>
          </div>

          <div className="space-y-6 px-4 py-8 sm:px-8 sm:py-10">
            {!isConnected && (
              <div className="flex items-center gap-3 rounded-2xl border border-amber-400/25 bg-amber-400/10 px-4 py-3 text-sm text-amber-200">
                <Wallet className="h-4 w-4 shrink-0" aria-hidden="true" />
                {t('tickets.connectToSee')}
              </div>
            )}

            {ticketType === 'Current' ? (
              <>
                <TicketGroup
                  title={t('tickets.dailyTitle')}
                  subtitle={t('tickets.dailySubtitle')}
                  items={tickets}
                  tone="cyan"
                />
                <TicketGroup
                  title={t('tickets.weeklyTitle')}
                  subtitle={t('tickets.weeklySubtitle')}
                  items={ticketsW}
                  tone="gold"
                />
              </>
            ) : (
              <>
                {/* Lottery picker */}
                <div className="lb-card p-5 sm:p-7">
                  <p className="lb-eyebrow">{t('tickets.lottery')}</p>
                  <h2 className="lb-heading mt-1 text-2xl">{t('tickets.pickPool')}</h2>
                  <div className="mt-5 flex flex-wrap gap-3">
                    {LOTTERIES.map((item) => (
                      <button
                        key={item.key}
                        onClick={item.onSelect}
                        aria-pressed={lottery === item.key}
                        className={`flex items-center gap-2 rounded-2xl border px-4 py-2.5 text-sm font-bold uppercase tracking-[0.14em] transition ${
                          lottery === item.key
                            ? 'border-amber-400 bg-amber-400/15 text-amber-200'
                            : 'border-white/10 bg-black/40 text-white/60 hover:border-white/25 hover:text-white'
                        }`}
                      >
                        <img src={item.icon} alt="" aria-hidden="true" className="h-5 w-5" />
                        <span className="notranslate">{item.label}</span>
                      </button>
                    ))}
                  </div>
                </div>

                <section className="lb-card p-5 sm:p-7">
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <div>
                      <p className="lb-eyebrow">{t('tickets.pastResults')}</p>
                      <h2 className="lb-heading mt-1 text-2xl sm:text-3xl">{t('tickets.dailyDraw')}</h2>
                    </div>
                    <DrawIdPicker
                      label="daily"
                      value={formInput.drawId}
                      max={currentDraw}
                      onChange={(e) => {
                        const integerValue = parseInt(e.target.value, 10);
                        updateFormInput({
                          ...formInput,
                          drawId: Number.isNaN(integerValue) ? '' : integerValue,
                        });
                      }}
                    />
                  </div>
                  <div className="mt-6">
                    {loading ? (
                      <div className="py-12">
                        <Spinner size="lg" />
                      </div>
                    ) : ticketsP.length > 0 ? (
                      <CarouselPage tickets={ticketsP} resetTickets={resetTickets} />
                    ) : (
                      <EmptyState
                        title={t('tickets.emptyDrawTitle')}
                        message={t('tickets.emptyDrawMessage')}
                        icon={TicketIcon}
                      />
                    )}
                  </div>
                </section>

                <section className="lb-card p-5 sm:p-7">
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <div>
                      <p className="lb-eyebrow">{t('tickets.pastResults')}</p>
                      <h2 className="lb-heading mt-1 text-2xl sm:text-3xl">{t('tickets.weeklyDraw')}</h2>
                    </div>
                    <DrawIdPicker
                      label="weekly"
                      value={formInputW.drawId}
                      max={currentWDraw}
                      onChange={(e) => {
                        const integerValue = parseInt(e.target.value, 10);
                        updateFormInputW({
                          ...formInputW,
                          drawId: Number.isNaN(integerValue) ? '' : integerValue,
                        });
                      }}
                    />
                  </div>
                  <div className="mt-6">
                    {loading ? (
                      <div className="py-12">
                        <Spinner size="lg" />
                      </div>
                    ) : ticketsPW.length > 0 ? (
                      <CarouselPage tickets={ticketsPW} resetTickets={resetTickets} />
                    ) : (
                      <EmptyState
                        title={t('tickets.emptyDrawTitle')}
                        message={t('tickets.emptyWeeklyMessage')}
                        icon={TicketIcon}
                      />
                    )}
                  </div>
                </section>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTickets;
